import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import { FormattedMessage } from 'react-intl';

import {
  Box,
  Typography,
  RadioGroup,
  Radio,
  FormControlLabel,
  FormControl,
  Tooltip
} from '@mui/material';

import EmailTemplateModal from './EmailTemplateModal';
import { EMAIL_TEMPLATE_DATA } from './data/emailConstants';

import useColorSystem from '../../hook/useColorSystem';

import * as basicConstants from '../../constants/basic';

import { handleColorSystem } from '../customComponent/colorSystem';
import { BoxBorderGrey } from '../customComponent/box';
import theme from '../../theme';


const EmailTemplate = (props) => {
  const {
    media,
    emailMediaData,
    emailTemplateType,
    handleEmailTemplateType,
    handleRemainbudget,
    selectedCampaign
  } = props;

  const [modalType, setModalType] = useState('');
  const { colorMedia, mainColor, lightColor, darkColor, w01Color } = useColorSystem();

  const filterEmailTemplateData = EMAIL_TEMPLATE_DATA.filter(el => el.media === media);

  const emailTemplateButton = (el) => {
    return (
      <BoxBorderGrey
        sx={{
          width: '240px',
          padding: '28px 4px',
          borderColor: emailTemplateType === el.name ? mainColor : theme.palette.grey.w300,
          color: emailTemplateType === el.name ? mainColor : theme.palette.grey.w600,
          textAlign: 'center',
          transition: 'all .5s',
          cursor: 'pointer',
          '&:hover': { borderColor: mainColor, color: mainColor }
        }}
      >
        {el.icon}
        <Typography sx={{ color: 'inherit', fontSize: theme.typography.body_sm }}>
          <FormattedMessage id={el.content} />
        </Typography>
      </BoxBorderGrey>
    )
  }

  const handleClickEmailButton = (name) => {
    if (media === 'GOOGLE' && !selectedCampaign?.length) {
      return;
    }

    handleEmailTemplateType(name);
    handleModalDetail(name);
  }

  const changeEmailTemplate = (e) => {
    const { value } = e.target;
    handleEmailTemplateType(value);
  }

  const changeRemainbudget = (e) => {
    const { value } = e.target;
    const boolValue = JSON.parse(value);
    handleRemainbudget(boolValue);
  }

  const handleModalDetail = (type) => {
    switch (type) {
      case basicConstants.EMAIL_TEMPLATE_REACH:
        setModalType(basicConstants.EMAIL_TEMPLATE_REACH);
        break;
      case basicConstants.EMAIL_TEMPLATE_COVERSION_METRICS:
        setModalType(basicConstants.EMAIL_TEMPLATE_COVERSION_METRICS);
        break;
      case basicConstants.EMAIL_TEMPLATE_COVERSION_CAMPAIGN:
        setModalType(basicConstants.EMAIL_TEMPLATE_COVERSION_CAMPAIGN);
        break;
      default:
        setModalType('');
        break;
    }
  }

  return (
    <>
      <FormControl>
        <RadioGroup
          value={emailTemplateType}
          onChange={changeEmailTemplate}
        >

          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-start'
            }}
          >
            {filterEmailTemplateData.map(el => {
              return (
                <Box
                  key={el.id}
                  sx={{
                    display: 'flex',
                    justifyContent: 'flex-start'
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItem: 'center',
                      flexDirection: 'column',
                      marginRight: '16px',
                    }}
                    onClick={() => handleClickEmailButton(el.name)}
                  >
                    {media === 'GOOGLE' && selectedCampaign.length <= 0 ? (
                      <Tooltip title={<FormattedMessage id="emailData.mail.tip" />} placement="right">
                        {emailTemplateButton(el)}
                      </Tooltip>
                    ) : (
                      emailTemplateButton(el)
                    )
                    }
                    <FormControlLabel
                      value={el.name}
                      label={<FormattedMessage id={el.label} />}
                      control={<Radio disabled={media === 'GOOGLE' && selectedCampaign.length <= 0 ? true : false} />}
                      sx={{ justifyContent: 'center', marginRight: 0 }}
                    />
                  </Box>
                </Box>
              )
            })
            }
          </Box>

        </RadioGroup>
      </FormControl>

      <EmailTemplateModal
        {...props}
        media={media}
        emailMediaData={emailMediaData}
        modalType={modalType}
        handleCloseModal={() => setModalType('')}
        changeRemainbudget={changeRemainbudget}
        filterEmailTemplateData={filterEmailTemplateData}
      />

    </>
  )
}

export default EmailTemplate;